<template>
  <!-- :class="`workpackage-subpage ${workpackage.color} ${!workpackage.color.includes('lighten') || !workpackage.color.includes('darken')?'lighten-1':''}`" -->
  <div
    :class="`workpackage-subpage`"
    :style="`
      ${(location === 'ProjectWallet' || isMobile)? 'position: absolute; z-index: 100;' : 'z-index: 10;'}
      background-color: ${background_color};
      `"
  >
  <!-- && !on_site - removed from line 6 -->
    <div :style="`${!on_site ? 'z-index: 100;' : 'z-index: 10;'}`">
      <slot name="dialog"/>
    </div>
    <div :class="`workpackage-subpage-separator ${workpackage.textcolor}`"/>
    <div
      class="workpackage-subpage-content"
      :style="location === 'ProjectWallet' || isMobile?'width: 100%;':''"
    >
      <!-- <slot name="header" :scroll_opacity="scroll_opacity"/> -->
      <SubpageHeader
        class="workpackage-subpage-content-header"
        v-if="!hide_subpage_header"
        :is_create_screen="is_create_screen"
        :on_site="on_site"
        :save_btn_loading="save_btn_loading"
        :background_color="background_color"
        :foreground_color="foreground_color"
        @backBtnClicked="$emit('headerBack', $event)"
        @saveBtnClicked="$emit('headerSave', $event)"
        @cancelBtnClicked="$emit('headerCancel', $event)"
      >
        <!-- :items="['Created', 'Updated', 'Deleted', 'Added', 'Removed', 'Comment']" -->
        <template #center>
          <div
            v-if="!is_create_screen && header_icon"
            class="workpackage-subpage-content-header-descriptor"
            :style="`
              background-color: ${background_color};
              opacity: ${scroll_opacity ? 1 : 0};
            `"
          >
            <TIcon
              :name="header_icon"
            />
            <TText :value="header_text_short" size="6" :color="foreground_color"/>
          </div>
        </template>
        <template #rightside>
          <slot name="header-rightside"/>
          <template v-if="header_options && !is_create_screen">
            <!-- OPTIONS TOGGLE -->
            <v-btn icon @click="show_header_options = !show_header_options">
              <TIcon
                name="vertical-dots"
              />
            </v-btn>

            <!-- ACTUAL OPTIONS -->
            <TransitionAccordion>
              <!-- TODO: check width. value seems to be NOT correct. works for now. -->
              <PopUpOverlay
                v-if="show_header_options"
                :width="`${header_options.count * 140}px`"
                :margin="8"
                :position_css="`
                  bottom: 0;
                  right: 10px;
                  transform: translate(0%, 100%);
                `"
                :is_no_cancel="true"
                @closeOverlay="show_header_options = false"
                :z_index="1"
              >
                <template #body>
                  <div class="work-package-step-detail-option-buttons">
                    <template v-for="(option, index) in header_options">
                    <ClickablePopUpIcon
                        v-if="option.show"
                        :key="`option-display${index}`"
                        :icon="option.icon"
                        :color="full_color"
                        :description="option.description"
                        :loading="option.delete_btn_loading"
                        @selected="$emit(`clickHeader${option.description}`)"
                      />
                    </template>
                  </div>
                </template>
              </PopUpOverlay>
            </TransitionAccordion>
          </template>
        </template>
        <template #below>
          <slot name="header-below"/>
        </template>
      </SubpageHeader>
      <div
        class="workpackage-subpage-content-body"
        :style="`
          ${location === 'ProjectWallet' || isMobile ? 'width: 100%;' : ''}
          ${on_site ? 'height: 100%;' : 'height: calc(100% - 46px);'}
          background-color: ${background_color};
          `"
        @scroll="set_scroll_opacity($event.target.scrollTop)"
        >
        <div
          v-if="header_icon || header_text_long"
          class="workpackage-subpage-content-body-descriptor d-flex"
          :style="`opacity: ${scroll_opacity ? 0 : 1};`">
          <TIcon
            class="mr-2"
            :name="header_icon"
          />
          <TText :value="header_text_long" medium :color="foreground_color"/>
          <div class="subpage-header-slot" :style="`color: ${foreground_color}`">
            <slot name="header-slot"/>
          </div>
        </div>
        <div class="workpackage-subpage-content-body-sort-buttons" :style="`background-color: ${background_color}; ${ !!$slots['sort-buttons'] ? 'padding-bottom: 4px;' : ''}`">
          <slot name="sort-buttons"/>
        </div>
        <slot name="body"/>
        <div class="d-flex justify-center" v-if="loading">
          <v-progress-circular indeterminate :color="workpackage.textcolor" style="opacity: 0.9"/>
        </div>
      </div>
    </div>
    <transition :name="location === 'ProjectWallet' || isMobile?'subage-slide-in':'appear'">
      <router-view/>
    </transition>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
  import TText from '@/components/Taktify/TText.component.vue';
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue';
  import ClickablePopUpIcon from '@/components/WorkPackageWIP/ClickablePopUpIcon.component.vue';
  import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
  import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    props: [
      'workpackage',
      'isMobile',
      'location',
      'loading',
      'foreground_color',
      'background_color',
      'header_icon',
      'header_text_short',
      'header_text_long',
      'is_create_screen',
      'save_btn_loading',
      'header_options',
      'delete_btn_loading',
      'hide_subpage_header'
    ],

    components: {
      SubpageHeader,
      TText,
      TIcon,
      PopUpOverlay,
      ClickablePopUpIcon,
      TransitionAccordion,
    },

    mixins: [
      TColor,
    ],

    data: () => ({
      // scroll_opacity: 1,
      scroll_opacity: false,
      show_header_options: false,
    }),

    computed: {
      full_color() {
        return this.getColor();
      },
      on_site() {
        return this.getUseOnSite;
      },
      ...mapGetters('View', [
        'getUseOnSite'
      ])
    },

    methods: {
      set_scroll_opacity(scroll_top) {
        if (1 - scroll_top / 30 > 0) {
          // this.scroll_opacity = 1 - scroll_top / 30;
          this.scroll_opacity = false;
        } else {
          // this.scroll_opacity = 0;
          this.scroll_opacity = true;
        }
      }
    },
  }
</script>
<style>
  .workpackage-subpage {
    position: relative;
    display: flex;
    flex-shrink: 0;
    height: 100%;
    width: 100%;
    z-index: 100;
  }
  .workpackage-subpage-separator {
    position: relative;
    display: flex;
    flex-shrink: 0;
    height: calc(100% - 10px);
    top: 5px;
    width: 1px;
    opacity: 0.2;
  }
  .workpackage-subpage-content {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
  }
  .workpackage-subpage-content-header {
    padding: 0px 10px;
  }
  .workpackage-subpage-content-header-descriptor {
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: none;
    width: 100%;
  }
  .workpackage-subpage-content-body-descriptor {
    margin-bottom: -8px;
    align-items: center;
  }
  .workpackage-subpage-content-body {
    position: relative;
    width: 320px;
    /* height: calc(100% - 46px); */
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-gap: 8px;
    overflow: auto;
    flex-shrink: 0;
    padding: 0px 10px 10px 10px;
    overflow-x: hidden;
    flex-shrink: 0;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
  }
  .workpackage-subpage-content-body::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
  }
  .workpackage-subpage-content-body-sort-buttons {
    display: flex;
    position: sticky;
    top: 0px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* z-index: 1; */
  }
  .work-package-step-detail-option-buttons {
    display: flex;
    flex-wrap: wrap;
    height: auto;
    width: 100%;
    align-items: center;
    grid-gap: 8px;
    padding: 16px;
    justify-content: space-between;
  }
  .subpage-header-slot {
    position: absolute;
    display: flex;
    align-items: center;
    right: 10px;
  }
  .workpackage-subpage-content-header-descriptor, .workpackage-subpage-content-body-descriptor {
    transition: opacity 0.1s ease-in-out;
  }
</style>
